"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncateChildren = truncateChildren;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function truncateChildren(children, truncated) {
  return _react.default.Children.map(children, function (child) {
    return _react.default.isValidElement(child) ? _react.default.cloneElement(child, {
      truncated: child.props.truncated !== undefined ? child.props.truncated : truncated
    }) : child;
  });
}